(() => {
  const root = document.querySelector('[data-pop1-qr-manager]');
  if (!root) return;

  const endpoint = (root.dataset.endpoint || '').trim();
  const publicBase = (root.dataset.publicBase || 'https://qr.pop1prints.com').replace(/\/$/, '');
  const els = {
    login: root.querySelector('[data-qr-login]'),
    app: root.querySelector('[data-qr-app]'),
    key: root.querySelector('[data-qr-key]'),
    loginBtn: root.querySelector('[data-qr-login-btn]'),
    logoutBtn: root.querySelector('[data-qr-logout]'),
    status: root.querySelector('[data-qr-status]'),
    list: root.querySelector('[data-qr-list]'),
    empty: root.querySelector('[data-qr-empty]'),
    form: root.querySelector('[data-qr-form]'),
    code: root.querySelector('[name="code"]'),
    label: root.querySelector('[name="label"]'),
    destination: root.querySelector('[name="destination_url"]'),
    customerRef: root.querySelector('[name="customer_reference"]'),
    createBtn: root.querySelector('[data-qr-create]'),
    refreshBtn: root.querySelector('[data-qr-refresh]'),
    count: root.querySelector('[data-qr-count]'),
  };

  let adminKey = sessionStorage.getItem('pop1QrAdminKey') || '';

  function setStatus(message, kind = '') {
    els.status.textContent = message || '';
    els.status.dataset.kind = kind;
  }

  function escapeHtml(value = '') {
    return String(value).replace(/[&<>'"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));
  }

  async function api(action, payload = {}) {
    if (!endpoint) throw new Error('QR Manager endpoint is not configured in the theme editor.');
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'x-pop1-admin-key': adminKey,
      },
      body: JSON.stringify({ action, ...payload }),
    });
    let data = {};
    try { data = await response.json(); } catch (_) {}
    if (!response.ok) throw new Error(data.error || `Request failed (${response.status})`);
    return data;
  }

  async function login() {
    adminKey = (els.key.value || '').trim();
    if (!adminKey) return setStatus('Enter your admin access key.', 'error');
    try {
      setStatus('Checking access…');
      await api('list');
      sessionStorage.setItem('pop1QrAdminKey', adminKey);
      els.login.hidden = true;
      els.app.hidden = false;
      els.key.value = '';
      setStatus('');
      await loadCodes();
    } catch (err) {
      setStatus(err.message, 'error');
    }
  }

  function logout() {
    sessionStorage.removeItem('pop1QrAdminKey');
    adminKey = '';
    els.app.hidden = true;
    els.login.hidden = false;
    els.list.innerHTML = '';
    setStatus('Signed out.', 'ok');
  }

  function rowTemplate(item) {
    const qrUrl = `${publicBase}/${encodeURIComponent(item.code)}`;
    const activeLabel = item.active ? 'Active' : 'Paused';
    const activeClass = item.active ? 'is-active' : 'is-paused';
    const scans = Number(item.scan_count || 0).toLocaleString();
    const last = item.last_scanned_at ? new Date(item.last_scanned_at).toLocaleString() : 'Not scanned yet';
    return `
      <article class="pop1-qr-row" data-id="${escapeHtml(item.id)}">
        <div class="pop1-qr-row__main">
          <div class="pop1-qr-row__topline">
            <strong>${escapeHtml(item.label || item.code)}</strong>
            <span class="pop1-qr-pill ${activeClass}">${activeLabel}</span>
          </div>
          <div class="pop1-qr-short">${escapeHtml(qrUrl)}</div>
          <div class="pop1-qr-destination">→ ${escapeHtml(item.destination_url)}</div>
          <div class="pop1-qr-meta">
            <span>${scans} scan${Number(item.scan_count || 0) === 1 ? '' : 's'}</span>
            <span>Last: ${escapeHtml(last)}</span>
            ${item.customer_reference ? `<span>Ref: ${escapeHtml(item.customer_reference)}</span>` : ''}
          </div>
        </div>
        <div class="pop1-qr-actions">
          <button type="button" class="button button--secondary" data-copy-url="${escapeHtml(qrUrl)}">Copy URL</button>
          <button type="button" class="button button--secondary" data-download-svg="${escapeHtml(item.code)}">QR SVG</button>
          <button type="button" class="button button--secondary" data-edit>Redirect</button>
          <button type="button" class="button button--secondary" data-toggle data-active="${item.active ? 'true' : 'false'}">${item.active ? 'Pause' : 'Activate'}</button>
        </div>
      </article>`;
  }

  async function loadCodes() {
    try {
      setStatus('Loading QR codes…');
      const data = await api('list');
      const items = data.items || [];
      els.list.innerHTML = items.map(rowTemplate).join('');
      els.empty.hidden = items.length > 0;
      els.count.textContent = items.length;
      bindRows();
      setStatus('');
    } catch (err) {
      setStatus(err.message, 'error');
      if (/unauthor/i.test(err.message)) logout();
    }
  }

  async function createCode(event) {
    event.preventDefault();
    const payload = {
      code: (els.code.value || '').trim(),
      label: (els.label.value || '').trim(),
      destination_url: (els.destination.value || '').trim(),
      customer_reference: (els.customerRef.value || '').trim(),
    };
    if (!payload.destination_url) return setStatus('Enter the destination URL.', 'error');
    try {
      els.createBtn.disabled = true;
      setStatus('Creating dynamic QR…');
      const data = await api('create', payload);
      els.form.reset();
      setStatus(`Created ${publicBase}/${data.item.code}`, 'ok');
      await loadCodes();
    } catch (err) {
      setStatus(err.message, 'error');
    } finally {
      els.createBtn.disabled = false;
    }
  }

  function bindRows() {
    els.list.querySelectorAll('[data-copy-url]').forEach(btn => {
      btn.addEventListener('click', async () => {
        await navigator.clipboard.writeText(btn.dataset.copyUrl);
        setStatus('QR URL copied.', 'ok');
      });
    });

    els.list.querySelectorAll('[data-edit]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const row = btn.closest('[data-id]');
        const current = row.querySelector('.pop1-qr-destination').textContent.replace(/^→\s*/, '');
        const next = window.prompt('New redirect destination:', current);
        if (!next || next === current) return;
        try {
          setStatus('Updating redirect…');
          await api('update', { id: row.dataset.id, destination_url: next });
          setStatus('Redirect updated. The printed QR stays the same.', 'ok');
          await loadCodes();
        } catch (err) { setStatus(err.message, 'error'); }
      });
    });

    els.list.querySelectorAll('[data-toggle]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const row = btn.closest('[data-id]');
        const next = btn.dataset.active !== 'true';
        try {
          setStatus(next ? 'Activating QR…' : 'Pausing QR…');
          await api('update', { id: row.dataset.id, active: next });
          setStatus(next ? 'QR activated.' : 'QR paused.', 'ok');
          await loadCodes();
        } catch (err) { setStatus(err.message, 'error'); }
      });
    });

    els.list.querySelectorAll('[data-download-svg]').forEach(btn => {
      btn.addEventListener('click', async () => {
        try {
          setStatus('Generating QR artwork…');
          const data = await api('svg', { code: btn.dataset.downloadSvg, public_base: publicBase });
          const blob = new Blob([data.svg], { type: 'image/svg+xml;charset=utf-8' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `POP1-QR-${btn.dataset.downloadSvg}.svg`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
          setStatus('QR SVG downloaded.', 'ok');
        } catch (err) { setStatus(err.message, 'error'); }
      });
    });
  }

  els.loginBtn?.addEventListener('click', login);
  els.key?.addEventListener('keydown', e => { if (e.key === 'Enter') login(); });
  els.logoutBtn?.addEventListener('click', logout);
  els.form?.addEventListener('submit', createCode);
  els.refreshBtn?.addEventListener('click', loadCodes);

  if (adminKey) {
    els.login.hidden = true;
    els.app.hidden = false;
    loadCodes();
  }
})();
